`
<div class="container container-main">
  <app-reports-general-header />
  <app-reporting-subnav></app-reporting-subnav>
  <div class="card border-0 p-3">
    <div class="card-body">
      <div class="d-flex w-100 justify-content-between mb-4">
        <h2 class="fw-bolder">Plans Report</h2>
        <div class="legend d-flex justify-content-end">
          <div class="legend-item">
            <div>%</div>
            <div class="legend-item-pill" style="width: 12px"></div>
          </div>
          <div class="legend-item">
            <div>&lt; 25</div>
            <div
              class="legend-item-pill"
              style="background-color: #f0eee9"></div>
          </div>
          <div class="legend-item">
            <div>25-50</div>
            <div
              class="legend-item-pill"
              style="background-color: #dcd6c5"></div>
          </div>
          <div class="legend-item">
            <div>50-75</div>
            <div
              class="legend-item-pill"
              style="background-color: #b1d8ee"></div>
          </div>
          <div class="legend-item">
            <div>75 +</div>
            <div
              class="legend-item-pill"
              style="background-color: #7cb9da"></div>
          </div>
          <div class="legend-item">
            <div>Proficient</div>
            <div
              class="legend-item-pill"
              style="background-color: #58a3cb"></div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <ng-container *ngIf="!isLoading">
            <button
              ngbTooltip="Download CSV"
              aria-label="Download CSV"
              class="btn"
              container="body"
              placement="bottom"
              [autoClose]="false"
              [ngbPopover]="csvDownloadingPopover"
              [disabled]="disableDownload"
              (click)="downloadCSV()"
              #p="ngbPopover">
              <i [ngClass]="['bi', 'fs-21', 'bi-download']"></i>
            </button>
            <ng-template #csvDownloadingPopover>
              <div class="p-2">
                Your report is generating. The download will begin shortly.
              </div>
              <div class="p-2 d-flex justify-content-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="p.close()">
                  OK
                </button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <app-report-filter-bar
        [canFilterByDistrict]="canFilterByDistrict"
        [reportName]="'implementationPlan'"></app-report-filter-bar>

      <div class="table-container">
        <table
          class="table table-plans"
          *ngIf="!isLoading; else loadingTemplate">
          <thead *ngIf="tableData && tableData.length > 0">
            <tr class="align-middle">
              <th scope="col" style="min-width: 250px">Plan Name</th>
              <ng-container
                *ngFor="
                  let phase of getUniquePhases();
                  let index = index;
                  trackBy: trackByPhase
                ">
                <th scope="col" style="min-width: 150px" class="phase-column">
                  Phase #{{ trackByPhase(index, phase) }}<br />
                  Name
                </th>
                <th scope="col" style="min-width: 80px" class="progress-column">
                  Phase #{{ trackByPhase(index, phase) }} <br />Progress
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngIf="tableData && tableData.length > 0; else noTableData">
              <tr *ngFor="let plan of tableData" class="align-middle">
                <td>
                  <a
                    routerLink="/plans/implementation-plan/{{
                      plan.plan_id
                    }}/details"
                    target="_blank"
                    class="overlap-text fw-bold"
                    title="{{ plan.plan_name }}"
                    >{{ plan.plan_name }}</a
                  >
                </td>
                <ng-container
                  *ngFor="
                    let phase of getUniquePhases();
                    trackBy: trackByPhase
                  ">
                  <ng-container
                    *ngIf="
                      getPhaseData(plan, phase.phase_num) as phaseData;
                      else emptyPhase
                    ">
                    <td class="phase-column">
                      {{ phaseData.phase_name }}
                    </td>
                    <td
                      class="text-center progress-column"
                      [style.background-color]="
                        getPhaseBackgroundColor(phaseData)
                      ">
                      <span class="fw-600">{{
                        phaseData.phase_progress_fraction
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-template #emptyPhase>
                    <td class="phase-column"></td>
                    <td class="text-center progress-column"></td>
                  </ng-template>
                </ng-container>
              </tr>
            </ng-container>
            <ng-template #noTableData>
              <tr>
                <td [attr.colspan]="getColumnCount()">
                  <p class="text-center my-5">No Plans Found.</p>
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
        <ng-template #loadingTemplate>
          <div class="loader-container">
            <app-loader></app-loader>
          </div>
        </ng-template>
      </div>
      <section>
        <div class="d-flex justify-content-center mt-4">
          <ngb-pagination
            *ngIf="!isLoading && listMeta && listMeta.totalCount > 10"
            [(page)]="listMeta.currentPage"
            [pageSize]="listMeta.perPage"
            [collectionSize]="listMeta.totalCount"
            [maxSize]="5"
            (pageChange)="paginationChange()"></ngb-pagination>
        </div>
      </section>
    </div>
    <div class="mt-5 text-muted small text-end">
      Data last refreshed at {{ lastUpdatedDate }}
    </div>
  </div>
</div>
